// import { BrowserRouter, Routes, Route  } from 'react-router-dom';
// import {Layout} from '../src/Components/Layout/layout'
// import i18n from './i18n';
// import { Root } from './Pages/root/root';
// import { SplocaIntroductionBox } from './Pages/HomePages/introduction';
// import { GovtOrdersComponent } from './Pages/HomePages/govtOrders/govtOrder';
// import { AssignedFinancialEstablishmentComponent } from './Pages/HomePages/financialEstablishment';
// import { CalenderEvents } from './Pages/HomePages/calenderEvents';
// import { HeadOffice } from './Pages/HomePages/headOffice';
// import { FEComponent } from './Pages/HomePages/fe';
// import { KpidActComponent } from './Pages/HomePages/kpidRules';
// import { BudsActComponent } from './Pages/HomePages/budsAct';
// import { DailyCourtCasesComponent } from './Pages/HomePages/dailyCourtReport';
// import { KeyJudgementComponent } from './Pages/HomePages/keyJudgement';
// import { CircularNotificationComponent } from './Pages/HomePages/circularNotification';
// import { TenderComponent } from './Pages/HomePages/tenders';
// import { AuctionComponent } from './Pages/HomePages/auction';
// import { AdvertisementComponent } from './Pages/HomePages/advertisements';
// import { DepositorInfoComponent } from './Pages/HomePages/infoToDepositor';
// import DisableInspect from './Components/disableInspect/disableInspect';
// import { OfficeOrders } from './Pages/HomePages/office_orders';
// import { ManualVideos } from './Pages/HomePages/manualVideos';
// import { RegistrationPage } from './Pages/account/account';
// import {ProtectedRoute} from "../src/Components/protectRoute/protectRoutesComponent"
// import LeftSideMenuLayout from './Components/naveBar2/navBar2';
// import ProfilePage from './Pages/account/profile';
// import { RoleBasedLogin } from './Pages/account/roleBasedLogin';
// import { LegalTeamComponent } from './Pages/HomePages/legalTeam';
// import { DailyHighCourtCasesComponent } from './Pages/HomePages/dailyHighCourtCases';
// import { DailySupremeCourtCasesComponent } from './Pages/HomePages/dailySupremeCourtCases';
// import { OtherStatePIDFEActComponent } from './Pages/HomePages/otherStatesPidfe';
// import { OtherReleventActComponent } from './Pages/HomePages/otherReleventActs';
// import { ComparisnOfActComponent } from './Pages/HomePages/comparisnOfActs';
// import { LegalTemplateComponent } from './Pages/HomePages/legalTemplate';
// import { FaqComponent } from './Pages/HomePages/faq';
// import { LegalBlogComponent } from './Pages/HomePages/legalQueries';
// import { ScamNewsComponent } from './Pages/HomePages/scamNews';
// import { OtherStateCourtComponent } from './Pages/HomePages/otherStateOrders';
// import { SupremeCourtComponent } from './Pages/HomePages/supremeCourtOrders';
// import { HighCourtComponent } from './Pages/HomePages/highCourtOrders';
// import { SOPComponent } from './Pages/HomePages/sopComponent';
// import { LegalOpinionComponent } from './Pages/HomePages/LegalOpenion';
// import { LegalResearchComponent } from './Pages/HomePages/legalResearch';
// import ClaimInstructionsPage from './Pages/claimMgmt/instructions/claimInstructions';
// import ClaimListPage from './Pages/claimMaster/claimList';
// import OrgChart from './Pages/orgChart/orgChart';
// import { GlobalSearchProvider } from './Components/searchHook/searchHooks';
// import useAuthRefreshOnLoad from './api/authRefresher';
// import NotFoundPage from './Pages/pageNotFound';
// import PropertyMap from './Pages/propertyMap/propertyMap';
// // import ClaimFormPage from './Pages/claimMaster/claimForm';
// // import { AuthProvider } from './pages/AuthContext';

// function App() {
//   useAuthRefreshOnLoad()
//   return (
//      <GlobalSearchProvider>
//      <BrowserRouter>
//      <DisableInspect/>
//        {/* <AuthProvider> */}
//       <Layout>
//       <Routes>
//         <Route path="/" element={<Root/>} />
//         <Route path= "/introduction/sploca" element={<SplocaIntroductionBox/>}/>
//         <Route path="/ca/authority/govtorders" element={<GovtOrdersComponent/>}/>
//         <Route path="/ca/authority/assingnedfe" element={<AssignedFinancialEstablishmentComponent/>}/>
//         <Route path="/about/calenderEvent" element={<CalenderEvents/>}/>
//         <Route path="/contact/departmentcontacts" element={<HeadOffice/>}/>
//         <Route path="/financial-establishments" element={<FEComponent/>}/>
//         <Route path="legal/law/kpid-act" element={<KpidActComponent/>}/>
//          <Route path="legal/law/legal-team" element={<LegalTeamComponent/>}/>
//         <Route path="legal/law/buds-act" element={<BudsActComponent/>}/>
//         <Route path="/legal/court-cases/daily-report" element={<DailyCourtCasesComponent/>}/>
//         <Route path="/legal/court-cases/key-judgements" element={<KeyJudgementComponent/>}/>
//         <Route path="/notification/circulars" element={<CircularNotificationComponent/>}/>
//         <Route path="/notification/public-notices/tender" element={<TenderComponent/>}/>
//         <Route path="/notification/public-notices/auction" element={<AuctionComponent/>}/>
//         <Route path="/notification/public-notices/adv" element={<AdvertisementComponent/>}/>
//         <Route path="/notification/public-notices/ice/info-to-depositors" element={<DepositorInfoComponent/>}/>
//         <Route path="/notification/sploca-circular/office-orders" element={<OfficeOrders/>}/>
//         <Route path="/notification/public-notices/ice/manuals-videos" element={<ManualVideos/>}/>
//         <Route path="/daily-high-court-cases" element={<DailyHighCourtCasesComponent/>}/>
//         <Route path="/daily-supreme-court-cases" element={<DailySupremeCourtCasesComponent/>}/>
//         <Route path="/other-state-pidfe" element={<OtherStatePIDFEActComponent/>}/>
//         <Route path="/other-relevent-acts" element={<OtherReleventActComponent/>}/>
//         <Route path="/comparisn-of-acts" element={<ComparisnOfActComponent/>}/>
//         {/* <Route path="/legal-template" element={<LegalTemplateComponent/>}/> */}
//         <Route path="/faq" element={<FaqComponent/>}/>
//         <Route path="/legal-blogs" element={<LegalBlogComponent/>}/>
//         <Route path="/scam-news" element={<ScamNewsComponent/>}/>

//         <Route path="/high-court-orders" element={<HighCourtComponent/>}/>
//         <Route path="/supreme-court-orders" element={<SupremeCourtComponent/>}/>
//         <Route path="/other-state-court-orders" element={<OtherStateCourtComponent/>}/>
//         <Route path="/sop" element={<SOPComponent/>}/>
//         <Route path="/legal-opinion" element={<LegalOpinionComponent/>}/>
//         <Route path="/legal-research" element={<LegalResearchComponent/>}/>
//         <Route path="/claim-instrucions" element={<ClaimInstructionsPage/>}/>
//         <Route path="/org-chart" element={<OrgChart/>}/>
        
        
//         {/* propery */}
//         <Route path="/properties" element={<PropertyMap />} />

//         {/* account urls */}
//         <Route path="/accounts" element={<RegistrationPage/>}/>
//         <Route path="/officers-login" element={<RoleBasedLogin/>}/>

//         {/* protected route */}
//         <Route element={<ProtectedRoute allowedRoles={[]}/>} >
//         <Route path="/claim-mgmt" element={<LeftSideMenuLayout/>} />
//         <Route path="/profile" element={<ProfilePage />} />
//         <Route path="/claims" element={<ClaimListPage />} />
      
//         {/* <Route path="/claims/new" element={<ClaimFormPage />} /> */}

//         {/* <Route path="/Admin" element={<AdminAdvertisementComponent />} /> */}

        
//         </Route>
        
//       <Route path="*" element={<NotFoundPage/>} />
//       </Routes>
//       </Layout>
//       {/* </AuthProvider> */}
//     </BrowserRouter>
//     </GlobalSearchProvider>
 
//   );
// }

// export default App;



import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Layout } from '../src/Components/Layout/layout';
import { Root } from './Pages/root/root';
import { SplocaIntroductionBox } from './Pages/HomePages/introduction';
import { GovtOrdersComponent } from './Pages/HomePages/govtOrders/govtOrder';
import { AssignedFinancialEstablishmentComponent } from './Pages/HomePages/financialEstablishment';
import { CalenderEvents } from './Pages/HomePages/calenderEvents';
import { HeadOffice } from './Pages/HomePages/headOffice';
import { FEComponent } from './Pages/HomePages/fe';
import { KpidActComponent } from './Pages/HomePages/kpidRules';
import { BudsActComponent } from './Pages/HomePages/budsAct';
import { DailyCourtCasesComponent } from './Pages/HomePages/dailyCourtReport';
import { KeyJudgementComponent } from './Pages/HomePages/keyJudgement';
import { CircularNotificationComponent } from './Pages/HomePages/circularNotification';
import { TenderComponent } from './Pages/HomePages/tenders';
import { AuctionComponent } from './Pages/HomePages/auction';
import { AdvertisementComponent } from './Pages/HomePages/advertisements';
import { DepositorInfoComponent } from './Pages/HomePages/infoToDepositor';
import DisableInspect from './Components/disableInspect/disableInspect';
import { OfficeOrders } from './Pages/HomePages/office_orders';
import { ManualVideos } from './Pages/HomePages/manualVideos';
import { RegistrationPage } from './Pages/account/account';
import { ProtectedRoute } from "../src/Components/protectRoute/protectRoutesComponent";
import LeftSideMenuLayout from './Components/naveBar2/navBar2';
import ProfilePage from './Pages/account/profile';
import { RoleBasedLogin } from './Pages/account/roleBasedLogin';
import { LegalTeamComponent } from './Pages/HomePages/legalTeam';
import { DailyHighCourtCasesComponent } from './Pages/HomePages/dailyHighCourtCases';
import { DailySupremeCourtCasesComponent } from './Pages/HomePages/dailySupremeCourtCases';
import { OtherStatePIDFEActComponent } from './Pages/HomePages/otherStatesPidfe';
import { OtherReleventActComponent } from './Pages/HomePages/otherReleventActs';
import { ComparisnOfActComponent } from './Pages/HomePages/comparisnOfActs';
import { LegalTemplateComponent } from './Pages/HomePages/legalTemplate';
import { FaqComponent } from './Pages/HomePages/faq';
import { LegalBlogComponent } from './Pages/HomePages/legalQueries';
import { ScamNewsComponent } from './Pages/HomePages/scamNews';
import { OtherStateCourtComponent } from './Pages/HomePages/otherStateOrders';
import { SupremeCourtComponent } from './Pages/HomePages/supremeCourtOrders';
import { HighCourtComponent } from './Pages/HomePages/highCourtOrders';
import { SOPComponent } from './Pages/HomePages/sopComponent';
import { LegalOpinionComponent } from './Pages/HomePages/LegalOpenion';
import { LegalResearchComponent } from './Pages/HomePages/legalResearch';
import ClaimInstructionsPage from './Pages/claimMgmt/instructions/claimInstructions';
import ClaimListPage from './Pages/claimMaster/claimList';
import OrgChart from './Pages/orgChart/orgChart';
import { GlobalSearchProvider } from './Components/searchHook/searchHooks';
import useAuthRefreshOnLoad from './api/authRefresher';
import NotFoundPage from './Pages/pageNotFound';
import PropertyMap from './Pages/propertyMap/propertyMap';
import store from './store';
// import LocationPermissionBanner from './Components/LocationPermissionBanner';

// Fix for i18n warning - initialize it properly
import './i18n';
import EkycCallback from './Pages/claimMaster/ekycStatus';
import LocationPermissionBanner from './Components/locationBanner/LocationPermissionBanner';

function App() {
  return (
    <Provider store={store}>
      <GlobalSearchProvider>
        <BrowserRouter>
          <DisableInspect />
          <AppContent />
        </BrowserRouter>
      </GlobalSearchProvider>
    </Provider>
  );
}

// Separate component to use hooks
function AppContent() {
  useAuthRefreshOnLoad();

  
  
  return (
    <>
    <LocationPermissionBanner />
    
    <Layout>
      <Routes>
        <Route path="/" element={<Root />} />
        <Route path="/introduction/sploca" element={<SplocaIntroductionBox />} />
        <Route path="/ca/authority/govtorders" element={<GovtOrdersComponent />} />
        <Route path="/ca/authority/assingnedfe" element={<AssignedFinancialEstablishmentComponent />} />
        <Route path="/about/calenderEvent" element={<CalenderEvents />} />
        <Route path="/contact/departmentcontacts" element={<HeadOffice />} />
        <Route path="/financial-establishments" element={<FEComponent />} />
        <Route path="/legal/law/kpid-act" element={<KpidActComponent />} />
        <Route path="/legal/law/legal-team" element={<LegalTeamComponent />} />
        <Route path="/legal/law/buds-act" element={<BudsActComponent />} />
        <Route path="/legal/court-cases/daily-report" element={<DailyCourtCasesComponent />} />
        <Route path="/legal/court-cases/key-judgements" element={<KeyJudgementComponent />} />
        <Route path="/notification/circulars" element={<CircularNotificationComponent />} />
        <Route path="/notification/public-notices/tender" element={<TenderComponent />} />
        <Route path="/notification/public-notices/auction" element={<AuctionComponent />} />
        <Route path="/notification/public-notices/adv" element={<AdvertisementComponent />} />
        <Route path="/notification/public-notices/ice/info-to-depositors" element={<DepositorInfoComponent />} />
        <Route path="/notification/sploca-circular/office-orders" element={<OfficeOrders />} />
        <Route path="/notification/public-notices/ice/manuals-videos" element={<ManualVideos />} />
        <Route path="/daily-high-court-cases" element={<DailyHighCourtCasesComponent />} />
        <Route path="/daily-supreme-court-cases" element={<DailySupremeCourtCasesComponent />} />
        <Route path="/other-state-pidfe" element={<OtherStatePIDFEActComponent />} />
        <Route path="/other-relevent-acts" element={<OtherReleventActComponent />} />
        <Route path="/comparisn-of-acts" element={<ComparisnOfActComponent />} />
        <Route path="/legal-template" element={<LegalTemplateComponent />} />
        <Route path="/faq" element={<FaqComponent />} />
        <Route path="/legal-blogs" element={<LegalBlogComponent />} />
        <Route path="/scam-news" element={<ScamNewsComponent />} />
        <Route path="/high-court-orders" element={<HighCourtComponent />} />
        <Route path="/supreme-court-orders" element={<SupremeCourtComponent />} />
        <Route path="/other-state-court-orders" element={<OtherStateCourtComponent />} />
        <Route path="/sop" element={<SOPComponent />} />
        <Route path="/legal-opinion" element={<LegalOpinionComponent />} />
        <Route path="/legal-research" element={<LegalResearchComponent />} />
        <Route path="/claim-instrucions" element={<ClaimInstructionsPage />} />
        <Route path="/org-chart" element={<OrgChart />} />
        <Route path="/properties" element={<PropertyMap />} />
        <Route path="/accounts" element={<RegistrationPage />} />
        <Route path="/officers-login" element={<RoleBasedLogin />} />
        <Route path="/ekyc-callback" element={<EkycCallback />} />
        
        {/* protected routes */}
        <Route element={<ProtectedRoute allowedRoles={[]} />}>
          <Route path="/claim-mgmt" element={<LeftSideMenuLayout />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/claims" element={<ClaimListPage />} />
        </Route>
        
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
    </>
  );

}

export default App;